import {Injectable} from '@angular/core';
import {ExceptionHandlerService} from '../../services/exception-handler-service';
import {Exception} from '../exception';
import {DialogService} from '../../services/dialog.service';

@Injectable()
export class ContentTooLargeExceptionHandlerService extends ExceptionHandlerService {

  constructor(private readonly dialogService: DialogService) {
    super();
  }

  handle(exception: Exception): void {
    if (exception?.clientException?.clientSubject && exception?.clientException?.clientBody) {
      this.dialogService.openExceptionDialog({
        data: {
          title: exception.clientException?.clientSubject,
          message: exception.clientException?.clientBody
        }
      });
    } else {
      this.dialogService.openExceptionDialog({
        data: {
          title: 'exceptions.contentTooLarge.modal.subject',
          message: 'exceptions.contentTooLarge.modal.body'
        }
      });
    }
  }

  isResponsible(httpError: any): boolean {
    return httpError.status === 413;
  }
}
